import { useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";

export function Portal({ children, selector }) {
   const ref: any = useRef();
   const [mounted, setMounted] = useState(false);

   useEffect(() => {
      ref.current = document.querySelector(selector);
      setMounted(true);
   }, [selector, ref]);

   return mounted ? createPortal(children, ref.current) : null;
}
